module.exports = __webpack_public_path__ + "static/media/fluids-feeding.e9b8acad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/learn/fluids-feeding.svg
// module id = 583
// module chunks = 31